<template>
<v-card class="overflow-hidden">
  <h2>hola</h2>
          <div v-for="item of links" :key="item.id" id="menulateral">
            <div class="row"><div class="card p-2 col-lg-2">{{ item.id }}</div><div class="card p-2 col-lg-10">{{ item.nombre }}</div></div>
        </div>
        <v-btn @click="getAllTiposDocumentos">Ver</v-btn>
       <v-select
            v-model="ejemplo"
            :items="getTipoDocumentos"
            item-text="desc_tipo_documento"
            :rules="[v => !!v || 'Debe seleccionar un Tipo de Documento']"
            item-value="id"
            label="Seleccionar Tipo de Docuemento"
            single-line
            prepend-icon="fa-id-card"
          ></v-select>
    </v-card>
</template>
<script>
import {mapState, mapActions, mapGetters } from 'vuex';
export default {
 
  data: () => ({
    name: "registroalumno",

  }),
  mounted() {
     this.getAllTiposDocumentos()
  },
  computed: {
    ...mapState(['links','nombre','TiposDocumentos']),
    ...mapGetters(['getTipoDocumentos'])
  },
  methods: {
  ...mapActions(['getAllTiposDocumentos'])
   },

};
</script>
<style scoped>
</style>